import React from "react";
import { useTranslation } from "react-i18next";
import {
  CartesianGrid,
  ResponsiveContainer,
  Scatter,
  ScatterChart,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { KeywordAnalysisKeyword } from "../../../../models/KeywordAnalysisData";

import "./styles.scss";

interface IKeywordScatterplotProps {
  keywords: KeywordAnalysisKeyword[];
}

const KeywordScatterplot: React.FunctionComponent<IKeywordScatterplotProps> = ({
  keywords,
}) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`facilityDetailsPage.keywordAnalysis.${key}`);

  const data = keywords.map((kw) => ({
    keyword: kw.keyword,
    review_mention_count: kw.review_mention_count,
    search_count_total: kw.search_count_total,
  }));

  return (
    <div className="keyword-analysis-scatterplot">
      <ResponsiveContainer>
        <ScatterChart {...{ overflow: "visible" }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            type="number"
            dataKey="review_mention_count"
            name={t("reviewMentionCount")}
            tick={{ fontSize: 12 }}
            style={{ fontFamily: "Inter" }}
            label={{
              value: t("reviewMentionCount"),
              position: "bottom",
              style: { fontFamily: "Inter" },
            }}
          />
          <YAxis
            type="number"
            dataKey="search_count_total"
            name={t("searchCountTotal")}
            tick={{ fontSize: 12 }}
            style={{ fontFamily: "Inter" }}
            label={{
              value: t("searchCountTotal"),
              angle: -90,
              position: "left",
              style: { fontFamily: "Inter" },
            }}
          />
          <Tooltip
            content={({ payload }) => {
              const d = payload?.[0]?.payload;
              if (!d) return null;
              return (
                <div className="keyword-analysis-scatterplot-tooltip">
                  <span className="tooltip-keyword">{d.keyword}</span>
                  <span>
                    {t("searchCountTotal")}:{" "}
                    {new Intl.NumberFormat("en").format(d.search_count_total)}
                  </span>
                  <span>
                    {t("reviewMentionCount")}:{" "}
                    {new Intl.NumberFormat("en").format(
                      d.review_mention_count
                    )}
                  </span>
                </div>
              );
            }}
          />
          <Scatter data={data} fill="#3241ff" />
        </ScatterChart>
      </ResponsiveContainer>
    </div>
  );
};

export default KeywordScatterplot;
